

<app-student-ai-timeline [studentId]="studentId"></app-student-ai-timeline>